export default "__VITE_ASSET__5bd7ee2c__"